module.exports = __webpack_public_path__ + "img/refresh2.8eff8e32.svg";